import { WidgetPlugin, WidgetSlot } from '../..';

export const mapWidgetPluginsForReplaceModal = (
  widgetPlugins: WidgetPlugin[],
) => {
  return widgetPlugins.map((widgetPlugin) => ({
    id: widgetPlugin.id,
    name: widgetPlugin.name,
    icon: widgetPlugin.logoUrl,
    placements: widgetPlugin.placements,
  }));
};

export const mapSlotsForReplaceModal = (
  slots: WidgetSlot[],
  hostAppName: string,
) => {
  return slots.map((slot) => ({
    widgetId: slot.placement.widgetId,
    slotId: slot.placement.slotId,
    widgetName: hostAppName,
    content: {
      appName: slot.pluginInfo?.name ?? '',
      name: slot.pluginInfo?.name ?? '',
      icon: slot.pluginInfo?.logoUrl,
    },
  }));
};
